import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import { useCallback } from 'react';

import { staffApi } from '../api/staff';

export const useRemoveStaff = () => {
  const queryClient = useQueryClient();

  const onSuccess = useCallback(() => {
    queryClient.invalidateQueries({ queryKey: ['adminUsers'] });
    message.success('Usuário excluído com sucesso.!');
  }, [queryClient]);

  const onError = useCallback(() => {
    message.error('O usuário não foi excluído. Tente novamente.');
  }, []);

  const { mutateAsync: removeStaff, isPending: isLoadingRemoveStaff } =
    useMutation({
      mutationFn: (userId: number) => staffApi.removeStaff(userId),
      onSuccess,
      onError,
    });

  return { removeStaff, isLoadingRemoveStaff };
};
